import { render, staticRenderFns } from "./OtpSignIn.vue?vue&type=template&id=353e940a&"
import script from "./OtpSignIn.vue?vue&type=script&lang=ts&"
export * from "./OtpSignIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports